import { isRegionId, type RegionId } from "@bible/overworld";
import { createFileRoute } from "@tanstack/react-router";
import { JourneyScreen } from "@ui/screens/JourneyScreen";

export interface JourneySearch {
  /** Set when arriving from an Overworld region tap — scopes the list to that region's chapters. */
  region?: RegionId;
}

export const Route = createFileRoute("/journey")({
  component: JourneyScreen,
  validateSearch: (search: Record<string, unknown>): JourneySearch => ({
    region: isRegionId(search.region) ? search.region : undefined,
  }),
});
